import isObject from "./is-object";
import toCamel from "./to-camel";
import isArray from "./is-array";

export default function keysToCamel(obj) {
  if (isObject(obj)) {
    const newObj = {};

    Object.keys(obj).forEach(key => {
      if (key.indexOf(".") < 0)
        newObj[toCamel(key.replace("?", ""))] = keysToCamel(obj[key]);
    });

    return newObj;
  } else if (isArray(obj)) {
    return obj.map(i => keysToCamel(i));
  }
  return obj;
}
